export const UPDATE_BASKET_FILTER = 'UPDATE_BASKET_FILTER';
export const DASHBOARD_CLEAR_ALL_FILTERS = 'DASHBOARD_CLEAR_ALL_FILTERS';
export const CLEAR_BASKET_FILTER = 'CLEAR_BASKET_FILTER';

export const updateBasketFilter = ({ filter, value }) => ({
  type: UPDATE_BASKET_FILTER,
  filter,
  value,
});

export const clearBasketFilter = filter => ({
  type: CLEAR_BASKET_FILTER,
  filter,
});

export const clearAllFilters = ({ shouldLog = false } = {}) => ({
  type: DASHBOARD_CLEAR_ALL_FILTERS,
  shouldLog,
});
